import { api } from '@/api/client'
import type { AppUpdatesMarkReadResponse, AppUpdatesResponse } from './types'

export function fetchAppUpdates() {
  return api<AppUpdatesResponse>('/api/app-updates')
}

export function markAppUpdatesRead(updateId?: number) {
  return api<AppUpdatesMarkReadResponse>('/api/app-updates/read', {
    method: 'POST',
    body: updateId ? { updateId } : {},
  })
}
